var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 355.906,
    height: 415.545,
    viewBox: "0 0 355.906 415.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125303",
    "data-name": "Group 125303",
    transform: "translate(19214 -17467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179814",
    "data-name": "Path 179814",
    d: "M297.5-462.6c-4.1,1.8-8.3,6.9-9.1,11a118.617,118.617,0,0,0-.2,14.4c.2,9.3.6,11.5,2.4,13.8,3.9,5.3,7.1,6.9,13.4,6.9s9.5-1.6,13.4-6.9c1.9-2.5,2.1-4.2,2.1-16.6,0-15.1-.5-16.7-6.7-21.3C309.5-463.8,301.5-464.5,297.5-462.6Z",
    transform: "translate(-19293.813 17930.684)",
    fill: "#13b576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179815",
    "data-name": "Path 179815",
    d: "M244.1-439.9c-9.7,2.1-15.3,13.8-10.8,22.5,2.7,5.1,16.9,18.1,21.3,19.4,8.2,2.4,17.2-2.8,19.5-11.3,1.8-6.7-.1-10.9-9-20C255.2-439.6,251.4-441.5,244.1-439.9Z",
    transform: "translate(-19293.813 17930.684)",
    fill: "#13b576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179816",
    "data-name": "Path 179816",
    d: "M357.5-440c-4.7,1-6.5,2.3-14.6,10.7-8.9,9.1-10.8,13.3-9,20,2.3,8.5,11.3,13.7,19.5,11.3,4.4-1.3,18.6-14.3,21.3-19.4,2-3.9,1.9-11-.4-14.8C370.8-438.1,363.9-441.4,357.5-440Z",
    transform: "translate(-19293.813 17930.684)",
    fill: "#13b576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179817",
    "data-name": "Path 179817",
    d: "M289-382.4c-12.3,3.3-12.7,3.7-64.1,63.6-36.4,42.4-47.9,56.5-48.4,59-.3,1.8-.4,47.9-.3,102.5.3,98.4.3,99.2,2.4,101.9a27.259,27.259,0,0,0,4.8,4.8c2.7,2.1,3.7,2.1,84.4,2.4,56.2.2,83.3-.1,87-.9,12.9-2.6,26.8-13.1,32.4-24.5,3.9-7.7,47.6-140.2,48.3-146.4,1.8-15.7-7.7-35.1-21.4-44-11.7-7.4-11.6-7.4-52.2-8l-36.6-.5,8.8-31c7.2-25,8.9-32.3,8.9-37.7A42.7,42.7,0,0,0,289-382.4Z",
    transform: "translate(-19293.813 17930.684)",
    fill: "#13b576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179818",
    "data-name": "Path 179818",
    d: "M116.1-270.5a49.251,49.251,0,0,0-34.6,35.2c-2.3,8.6-2.2,142.1,0,150.8a49.043,49.043,0,0,0,37.9,35.6c3.3.6,11.4.9,18.2.7,13.3-.3,15.3-1,19.8-7.2,2.1-2.7,2.1-3.3,2.1-104.6s0-101.9-2.1-104.6c-4.7-6.4-6.3-6.9-21.7-7.1C125.6-271.9,119.9-271.5,116.1-270.5Z",
    transform: "translate(-19293.813 17930.684)",
    fill: "#13b576"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeView);
export default __webpack_public_path__ + "static/media/like-view.319bba423ed30e28b92f73677450356c.svg";
export { ForwardRef as ReactComponent };